export function handlePermissionData(rows) {
  let region = [];
  let shop = [];
  rows.forEach((v) => {
    if (v.Region === v.Shop) {
      if (!region.includes(v.Region)) region.push(v.Region);
    } else {
      if (!shop.some((item) => item.Shop === v.Shop)) {
        shop.push({ region: v.Region, shop: v.Shop });
      }
    }
  });
  return { region, shop };
}
